import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

import hero from "client/assets/sidebar-hero.png";
import { useBranding } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";
import { BrandTitle } from "client/utils/branding";

const useStyles = makeStyles((theme: Theme) => {
  const { gray96 } = useNormalizedBrandPaletteValues(theme);

  return {
    root: {
      "& > *": {
        marginBottom: theme.spacing(4),
      },
      backgroundColor: gray96,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(4, 2.8, 2, 2.8),
    },
    sectionHeader: {
      fontSize: "0.9rem",
      fontWeight: theme.typography.fontWeightBold,
      marginBottom: theme.spacing(0.6),
    },
    sectionBody: {
      fontSize: "0.9rem",
    },
    heading: {
      fontWeight: theme.typography.fontWeightBold,
    },
  };
});

const Section: React.FC<{ header: string; body: string }> = ({
  header,
  body,
}) => {
  const classes = useStyles();
  return (
    <Box>
      <Typography variant="body2" className={classes.sectionHeader}>
        {header}
      </Typography>
      <Typography className={classes.sectionBody} variant="body2">
        {body}
      </Typography>
    </Box>
  );
};

const getSectionsWithBranding = (brandTitle: BrandTitle) => [
  {
    header: "New customers",
    body: `Our service gets people to try new places. On average, 30% of a store’s ${brandTitle} users are shopping there for the first time.`,
  },
  {
    header: "Higher order values",
    body: `Our global ${brandTitle} community buys more. Stores that welcome our members can boost average order values by up to 40%.`,
  },
  {
    header: "More conversion",
    body: `Our online shopping technology converts. ${brandTitle} can grow cart conversions by up to 22%—plus more repeat shoppers.`,
  },
];

export const Sidebar: React.FC = () => {
  const classes = useStyles();
  const { brandTitle } = useBranding();
  return (
    <Box
      className={classes.root}
      display="flex"
      flexDirection="column"
      mt={{ xs: 5, md: 0 }}
    >
      <Box display="flex" justifyContent="center">
        <img src={hero} alt="girl listening to music" />
      </Box>
      <Box>
        <Typography className={classes.heading} variant="h6">
          How {brandTitle} pays off
        </Typography>
      </Box>
      {getSectionsWithBranding(brandTitle).map(({ header, body }) => (
        <Section key={header} header={header} body={body} />
      ))}
    </Box>
  );
};
